import {
  afterRenderEffect,
  AfterViewInit,
  Component,
  effect,
  inject,
  OnInit,
  Pipe,
  PipeTransform,
  PLATFORM_ID
} from '@angular/core';
import { ScriptLoaderService } from './core/script-loader.service';
import {CommonModule, isPlatformBrowser} from '@angular/common';
import {
  Router,
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router';
import {addIcons} from "ionicons";
import {
  callOutline,
  caretDownOutline,
  globeOutline,
  arrowBack,
  locationOutline,
  removeOutline,
  logoFacebook,
  logoInstagram,
  logoTiktok,
  logoWhatsapp,
  logoX,
  logoYoutube,
  mailOutline,
  options,
  optionsOutline,
  search,
  logoSnapchat,
  logoLinkedin,
  shareSocialOutline,
  shareOutline,
  star,
  add,
  close,
  remove,
  moonOutline,
  calendarOutline,
  timeOutline,
  accessibility,
  arrowBackOutline,
  arrowForwardOutline,
  location,
  chevronForwardOutline,
  grid,
  openOutline,
  addOutline,
  chevronDownOutline,
  ticketOutline,
  cloudUploadOutline,
  copyOutline,
  checkmarkCircleOutline,
  personCircleOutline,
  person,
  heart,
  heartOutline,
  lockClosedOutline,
  lockClosed
} from "ionicons/icons";
import {
  IonButton, IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonMenu,
  IonMenuToggle, IonRouterOutlet,
  IonSplitPane, IonTitle,
  IonToolbar,
  ModalController
} from "@ionic/angular/standalone";
import {LanguageService} from "./core/language.service";
import {ReactiveFormsModule} from "@angular/forms";
import {OnetimePopupComponent} from "./common/onetime-popup/onetime-popup.component";
import {MobileNavComponent} from './common/mobile-nav/mobile-nav.component';
import {LogoComponent} from './common/header/logo/logo.component';
import {MobileFilterMenuComponent} from './common/mobile-filter-menu/mobile-filter-menu.component';
import {PerformanceMonitorComponent} from './common/performance-monitor/performance-monitor.component';
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import { NetworkOptimizationService } from './core/network-optimization.service';
import { BundleOptimizationService } from './core/bundle-optimization.service';
import { CriticalPathOptimizerService } from './core/critical-path-optimizer.service';
import {take} from 'rxjs';
import { InteractionListenerService } from './core/interaction-listener.service';

@Pipe({
  name: "cityFilter",
  standalone: true
})
export class CityFilterPipe implements PipeTransform {
  transform(value: any, arg: string): any {
    if (arg) {
      return value.filter((item: any) => item.toLowerCase().includes(arg.toLowerCase()));
    } else {
      return value;
    }
  }
}

@Component({
  selector: 'app-root',
  imports: [CommonModule, IonRouterOutlet, IonSplitPane, IonContent, IonMenu, IonHeader, IonToolbar, IonIcon, ReactiveFormsModule, IonButton, IonMenuToggle, MobileNavComponent, LogoComponent, IonButtons, TranslateModule, MobileFilterMenuComponent, IonTitle, PerformanceMonitorComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements AfterViewInit, OnInit {
  title = 'SATEL';
  isLoading = true;
  hideFab = false;

  modalController: ModalController = inject(ModalController);
  isLoaded = false;
  languageService: LanguageService = inject(LanguageService);
  private platformId = inject(PLATFORM_ID);
  private networkOptimizationService = inject(NetworkOptimizationService);
  private bundleOptimizationService = inject(BundleOptimizationService);
  private criticalPathOptimizer = inject(CriticalPathOptimizerService);
  private isBrowser = isPlatformBrowser(this.platformId);
  private scriptLoaderService = inject(ScriptLoaderService);
  private interactionListener = inject(InteractionListenerService);

  constructor(private router: Router,
              private translate: TranslateService) {
    // ... (constructor logic remains the same)
    // Load only critical icons initially
    addIcons({
      arrowBack,
      search,
      close,
      location,
      person,
      heart,
      heartOutline
    });

    // Defer loading of non-critical icons using requestIdleCallback
    if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
      (window as any).requestIdleCallback(() => {
        addIcons({
          logoFacebook, logoInstagram, logoX, logoTiktok, logoYoutube, logoWhatsapp, mailOutline, callOutline,
          locationOutline, globeOutline, caretDownOutline, options, optionsOutline, logoSnapchat, logoLinkedin,
          star, add, remove, calendarOutline, timeOutline, accessibility, copyOutline, arrowBackOutline,
          chevronForwardOutline, grid, openOutline, ticketOutline, cloudUploadOutline, removeOutline,
          shareSocialOutline, shareOutline, addOutline, moonOutline, lockClosedOutline, personCircleOutline,
          chevronDownOutline, lockClosed, checkmarkCircleOutline, arrowForwardOutline
        });
      }, { timeout: 2000 });
    } else {
      setTimeout(() => {
        addIcons({
          logoFacebook, logoInstagram, logoX, logoTiktok, logoYoutube, logoWhatsapp, mailOutline, callOutline,
          locationOutline, globeOutline, caretDownOutline, options, optionsOutline, logoSnapchat, logoLinkedin,
          star, add, remove, calendarOutline, timeOutline, accessibility, copyOutline, arrowBackOutline,
          chevronForwardOutline, grid, openOutline, ticketOutline, cloudUploadOutline, removeOutline,
          shareSocialOutline, shareOutline, addOutline, moonOutline, lockClosedOutline, personCircleOutline,
          chevronDownOutline, lockClosed, checkmarkCircleOutline, arrowForwardOutline
        });
      }, 2000);
    }

    // Subscribe to router events to control the loader and other UI elements
    this.router.events.subscribe((event: RouterEvent) => {
      this.handleRouterEvent(event);
    });

    effect(async () => {
      if (this.languageService.lang()) {
        console.log('lang ', this.languageService.lang(), ' dir', this.languageService.dir())
        this.useLanguage(this.languageService.lang());
      }
    });

    afterRenderEffect(() => {
      if (this.languageService.lang()) {
        // console.log('lang 2', this.languageService.lang(), ' dir', this.languageService.dir())
      }
    });
  }

  private handleRouterEvent(routerEvent: RouterEvent): void {
    if (routerEvent instanceof NavigationStart) {
      this.isLoading = true;
    }

    if (routerEvent instanceof NavigationEnd ||
      routerEvent instanceof NavigationCancel ||
      routerEvent instanceof NavigationError) {
      this.isLoading = false;
      this.hideFab = this.router.url.includes('/p/');
    }
  }

  async showOnetimePopup() {
    const modal = await this.modalController
      .create({
        component: OnetimePopupComponent,
        backdropDismiss: true,
        cssClass: 'onetime-popup'
      });
    await modal?.present();
  }

  ngOnInit(): void {
    this.translate.addLangs(['en', 'ar']);
    this.translate.setDefaultLang('ar');
    this.translate.use(this.languageService.lang());

    this.translate.onLangChange.subscribe(() => {
      // ...
    });

    if (this.isBrowser) {
      // Use requestIdleCallback to defer non-critical optimization work
      const scheduleIdleWork = (callback: () => void, timeout = 2000) => {
        if ('requestIdleCallback' in window) {
          (window as any).requestIdleCallback(callback, { timeout });
        } else {
          setTimeout(callback, 100);
        }
      };

      // Defer all optimization services to idle time to reduce TBT
      scheduleIdleWork(() => {
        this.criticalPathOptimizer.initializeMonitoring();
        this.networkOptimizationService.applyOptimizationStrategy();
        this.bundleOptimizationService.preloadCriticalChunks();
        this.bundleOptimizationService.optimizeFontLoading();
        this.bundleOptimizationService.monitorChunkPerformance();
      }, 1000);

      scheduleIdleWork(() => {
        this.networkOptimizationService.deferNonCriticalResources();
        this.networkOptimizationService.setupLazyBundleLoading();
        this.bundleOptimizationService.optimizeChunkLoading();
      }, 3000);
    }
    this.initThirdPartyScriptsOnInteraction();
  }

  ngAfterViewInit() {
    this.isLoaded = true;
  }

  private initThirdPartyScriptsOnInteraction(): void {
    if (!this.isBrowser) {
      return;
    }

    this.interactionListener.firstInteraction$.pipe(
      take(1)
    ).subscribe(() => {
      console.log('User has interacted with the page. Loading third-party scripts now.');
      this.scriptLoaderService.loadGTM('GTM-MQGR84P7');
      this.scriptLoaderService.loadGoogleAnalytics('G-VJ28XRQ95E');
      this.scriptLoaderService.loadGoogleAds('AW-11491373825');
      this.scriptLoaderService.loadHotjar(6414759, 6);
    });
  }

  useLanguage(language: string): void {
    this.translate.use(language);
  }
}
